module.exports = __webpack_public_path__ + "img/kotcLogo.f703fa67.png";